import type { BasicCustomMailRequiredItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductPlanI18nFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	atCreated: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtCreatedForText: (value: string) => void;
	handleClickedSendTestEmailReservationCreated: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	atUpdated: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	handleClickedSendTestEmailReservationUpdated: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	onSetAtUpdatedForText: (value: string) => void;
	atCanceled: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtCanceledForText: (value: string) => void;
	handleClickedSendTestEmailReservationCanceled: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	hotelEmailAddress: string;
	basicCustomMailSetting: ProductPlanI18nFormModel["QueryData"]["basicCustomMailSetting"];
	defaultPlanCustomMailSetting: ProductPlanI18nFormModel["QueryData"]["defaultPlanCustomMailSetting"];
	lang: LangCode;

	/** 基本メール設定の文言 */

	title?: string;
	guide?: string;
};

export const ForTriggerReservationEmailTemplates = ({
	isEdited,
	hasError,
	atCreated,
	onSetAtCreatedForText,
	handleClickedSendTestEmailReservationCreated,
	atUpdated,
	onSetAtUpdatedForText,
	handleClickedSendTestEmailReservationUpdated,
	atCanceled,
	onSetAtCanceledForText,
	handleClickedSendTestEmailReservationCanceled,
	hotelEmailAddress,
	basicCustomMailSetting,
	defaultPlanCustomMailSetting,
	lang,

	title: _title,
	guide: _guide,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約成立時"}
						textValue={atCreated?.text.value}
						textErrorMessage={atCreated?.text.error}
						handleChangeText={onSetAtCreatedForText}
						sendTestEmail={handleClickedSendTestEmailReservationCreated}
						hotelEmailAddress={hotelEmailAddress}
						isOverride={defaultPlanCustomMailSetting?.atCreated?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCreated}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約が変更された時"}
						textValue={atUpdated?.text.value}
						textErrorMessage={atUpdated?.text.error}
						handleChangeText={onSetAtUpdatedForText}
						sendTestEmail={handleClickedSendTestEmailReservationUpdated}
						hotelEmailAddress={hotelEmailAddress}
						isOverride={defaultPlanCustomMailSetting?.atUpdated?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atUpdated}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約がキャンセルされた時"}
						textValue={atCanceled?.text.value}
						textErrorMessage={atCanceled?.text.error}
						handleChangeText={onSetAtCanceledForText}
						sendTestEmail={handleClickedSendTestEmailReservationCanceled}
						hotelEmailAddress={hotelEmailAddress}
						isOverride={defaultPlanCustomMailSetting?.atCanceled?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCanceled}
					/>
				</div>
			}
		/>
	);
};

ForTriggerReservationEmailTemplates.displayName = "ForTriggerReservationEmailTemplates";
